// extracted by mini-css-extract-plugin
export default {"container":"Ford_container__EJMZ4","white":"Ford_white__1lNx7"};